"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textSharedPropTypes = exports.textPropTypes = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _propTypes = require("../prop-types");
var _interfaces = require("./interfaces");
const textSharedPropTypes = exports.textSharedPropTypes = {
  ..._propTypes.colorPropTypes,
  ..._propTypes.displayPropTypes,
  ..._propTypes.fontPropTypes,
  hyphens: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'hyphens' property for the element that determines whether text should be hyphenated when it wraps."),
  lineHeight: (0, _propTypes.cssValue)().description("Sets the CSS 'line-height' property for the element."),
  shouldUseFixedFontStyle: _stencilReactDesc.PropTypes.bool.description("Fixing the text's font style for all screen sizes."),
  textAlign: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'text-align' property for the element."),
  variant: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.TextVariant)).description('Sets the variant style for the component. Heading components only support Heading and Display variants.'),
  wordBreak: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'word-break' property for the element that specifies how text should wrap when there isn't enough space.")
};
const textPropTypes = exports.textPropTypes = {
  ...textSharedPropTypes,
  textDecoration: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'text-decoration' property for the element.")
};